module.exports = __webpack_public_path__ + "img/eyeopen.eeaa7f84.svg";